/** css */
import './GanttMassiveDuration.css';
import GanttMassiveDuration from './GanttMassiveDuration';

export default GanttMassiveDuration;
